<template>
  <div>
    <v-card
      v-if="parseInt(step) === 4 && !restricoes.dialogNutrientes && !$store.state.app.loading"
      class="mb-3"
    >
      <v-sheet :class="($vuetify.breakpoint.width >= 1000) ? 'pa-3 primary': ''">
        <v-layout
          justify-space-between
          row
          wrap>
          <v-flex
          v-if="!verificaPecuarista()"
            :class="($vuetify.breakpoint.width >= 1000) ? '': 'pa-3 primary'"
            xs12
            md9>
            <v-text-field
              v-model="restricoes.searchRestricao"
              :label="strings[idioma].pesquisar"
              dark
              flat
              solo-inverted
              hide-details
              clearable
              append-icon="mdi-magnify"
              clear-icon="mdi-close"
            />
          </v-flex>
          <v-flex
            v-else
            :class="($vuetify.breakpoint.width >= 1000) ? '': 'pa-3 primary'"
            xs12
            md12>
            <v-text-field
              v-model="restricoes.searchRestricao"
              :label="strings[idioma].pesquisar"
              dark
              flat
              solo-inverted
              hide-details
              clearable
              append-icon="mdi-magnify"
              clear-icon="mdi-close"
            />
          </v-flex>
          <v-divider horizontal/>
          <v-flex
            v-if="!verificaPecuarista()"
            xs12
            md3
            style="padding: 0px 10px 0px 10px; padding-right: -5px; margin-top: -5px"
            @click="!acesso_premium ? sejaPremium() : null">
            <v-radio-group
              v-model="restricoes.tipoEntrada"
              v-bind="binding"
              :style="($vuetify.breakpoint.width >= 1000) ? 'background-color: #fff; padding: 5px; margin-left: 20px; border-radius: 10px;' : 'padding: 5px; margin-left: 20px; border-radius: 10px;'"
              :dark="!$vuetify.breakpoint.width >= 1000"
              :disabled="(leituraBloqueada || !acesso_premium)"
              class="flex-center"
              center
              flat
              small
              row
              solo-inverted
              hide-details
              clearable
            >
              <v-radio
                v-for="option in [{'id': '/MS','nome': strings[idioma]['/MS'] },{'id': '/%','nome': strings[idioma]['/%']}]"
                :key="option.id"
                :label="option.nome"
                :value="option.id"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-sheet>
      <div
        v-if="restricoes.tipoEntrada === '/%'"
        class="error pa-2 text-xs-center">

        <span
          class="white--text"
        >
          {{ strings[idioma].msg_restricoes_ms }}</span>

      </div>
      <v-layout
        v-if="loading"
        :style="{'height': heightCard}"
        column
        fill-height
        justify-center
        align-center
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate />
      </v-layout>
      <v-data-table
        v-if="parseInt(step) === 4 && !restricoes.dialogNutrientes"
        v-show="!loading"
        :items="getAlimentosToEdit"
        :pagination.sync="restricoes.pagination"
        :search="restricoes.searchRestricao"
        :custom-filter="filterTable"
        :headers="[
          {
            text: 'alimento',
            value: 'name'
          }
        ]"
        :no-results-text="strings[idioma].sem_resultado"
        hide-actions
        hide-headers
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td style="padding: 0px">
            <v-layout
              align-center
              justify-space-around
              row
              wrap
              style="width: 100%"
            >

              <v-flex
                xs12
                lg5>
                <v-layout
                  :justify-center="$vuetify.breakpoint.xs"
                  row
                >

                  <v-btn
                    v-if="!props.item.restrito"
                    :disabled="user.permissao !== 0 && (props.item.restrito || leituraBloqueada || (String(props.item.id).startsWith('USR|') && props.item.id_pessoa === user.id) || props.item.EXCLUIDO === 1)"
                    :small="$vuetify.breakpoint.xs"
                    :color="(!props.item.alterado && !props.item.id_alimento_pai) ? undefined : 'warning'"
                    flat
                    @click="restricoes.indexAlimentoDialog = alimentos_selecionados.findIndex(el => el.id === props.item.id); $emit('dialogNutrientes', true)">
                    <v-icon
                      v-if="!leituraBloqueada"
                      left
                      dark>mdi-pencil</v-icon>
                    {{ idioma === 0 ? 
                      (!props.item.alterado && !props.item.id_alimento_pai) ? props.item.name : (props.item.name + ' *')
                       :
                       (idioma === 1)?
                        ((!props.item.alterado && !props.item.id_alimento_pai) ? props.item.name_en : props.item.name_en + ' *')
                        :
                        ((!props.item.alterado && !props.item.id_alimento_pai) ? props.item.name_es : props.item.name_es + ' *')
                    }}
                    {{ props.item.voltou_original === true ? ' [Original]' : '' }}
                  </v-btn>
                  <v-btn
                    v-else
                    :disabled="user.permissao !== 0 && (props.item.restrito || leituraBloqueada || (String(props.item.id).startsWith('USR|') && props.item.id_pessoa === user.id) || props.item.EXCLUIDO === 1)"
                    :small="$vuetify.breakpoint.xs"
                    :color="(!props.item.alterado && !props.item.id_alimento_pai) ? undefined : 'warning'"
                    flat>
                    <v-icon
                      v-if="!leituraBloqueada"
                      left
                      color="error"
                      dark>mdi-lock</v-icon>
                    {{ !idioma ? (!props.item.alterado && !props.item.id_alimento_pai) ? props.item.name : (props.item.name + ' *') : ((!props.item.alterado && !props.item.id_alimento_pai) ? props.item.name_en : props.item.name_en + ' *') }}
                    {{ props.item.voltou_original === true ? ' [Original]' : '' }}
                  </v-btn>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                lg7>
                <v-layout
                  justify-space-around
                  row
                  pb-2
                  pt-2
                >
                  <v-flex
                    pr-1
                    pl-1
                    xs4>
                    <v-layout
                      align-center
                      justify-center
                      column
                    >

                      <v-menu
                        :close-on-content-click="true"
                        :top="menuPosition === 'top'"
                        :botton="menuPosition === 'botton'"
                        right
                        offset-y
                        transition="slide-x-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-if="(props.item.custo !== null && props.item.custo !== NaN)"
                            :disabled="edicaoBloqueada"
                            :name="'custo[' + props.item.id + ']'"
                            v-model.lazy="props.item.custo"
                            outline
                            class="text-field-table"
                            color="primary"
                            pattern="\d*"
                            inputmode="decimal"
                            v-on="on"
                            @click.native="testMenuPosition"
                            @keypress="val => onlyFloat(val, props.item, 'custo')"
                            @dblclick="(props.item.custo === 0 || props.item.custo === '') ? props.item.custo = getCustoSalvo(props.item) : null"
                            @change="val => setCusto(val, props.item)"
                          />
                          <v-text-field
                            v-else
                            v-model.lazy="props.item.custo"
                            :disabled="edicaoBloqueada"
                            outline
                            class="text-field-table"
                            color="primary"
                            pattern="\d*"
                            inputmode="decimal"
                            v-on="on"
                            @click.native="testMenuPosition"
                            @keypress="val => onlyFloat(val, props.item, 'custo')"
                            @dblclick="props.item.custo = getCustoSalvo(props.item)"
                            @change="$store.commit('setDietaCalculada', false)"
                          />
                        </template>

                        <v-card :style="(getCustosSalvos(props.item).length === 0) ? 'height:0px; display:none;' : ''">
                          <v-list :style="heightHint">
                            <v-list-tile
                              v-for="(item, index) in new Set(getCustosSalvos(props.item).map(i => i.toFixed(2).replace('.', strings[idioma].separador_float)))"
                              :key="index"
                              @click="props.item.custo = item"
                            >
                              <v-list-tile-content>
                                <v-list-tile-title>{{ item }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </v-menu>
                      <div :class="$vuetify.breakpoint.xs ? 'small-text' : ''">{{ strings[idioma].custo_total }}</div>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    pr-1
                    pl-1
                    xs4>
                    <v-layout
                      align-center
                      justify-center
                      column
                    >
                      <v-menu
                        :close-on-content-click="true"
                        :top="menuPosition === 'top'"
                        :botton="menuPosition === 'botton'"
                        right
                        offset-y
                        transition="slide-x-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :disabled="user.permissao !== 0 && (edicaoBloqueada || (props.item.id === ID_LEITE_VACA && restricoes.tipoEntrada !== '/MS'))"
                            :name="'minimo[' + props.item.id + ']'"
                            v-model.lazy="props.item.minimo"
                            outline
                            class="text-field-table"
                            color="primary"
                            pattern="\d*"
                            inputmode="decimal"
                            v-on="on"
                            @click.native="testMenuPosition"

                            @keypress="val => onlyFloat(val, props.item, 'minimo')"
                            @dblclick="(props.item.minimo === 0 || props.item.minimo === '') ? props.item.minimo = getMinimoSalvo(props.item) : null"
                            @change="(val) => setMinimo(val, props.item)"
                          />
                        </template>
                        <v-card :style="(getMinimosSalvos(props.item).length === 0) ? 'height:0px; display:none;' : ''">
                          <v-list :style="heightHint">
                            <v-list-tile
                              v-for="(item, index) in new Set(getMinimosSalvos(props.item).map(i => i.toFixed(2).replace('.', strings[idioma].separador_float)))"
                              :key="index"
                              @click="props.item.minimo = item"
                            >
                              <v-list-tile-content>
                                <v-list-tile-title>{{ item }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </v-menu>
                      <div
                        v-if="restricoes.tipoEntrada === '/MS' || props.item.id === ID_LEITE_VACA"
                        :class="$vuetify.breakpoint.xs ? 'small-text' : ''">{{ strings[idioma].minimo }}</div>
                      <div
                        v-else
                        :class="$vuetify.breakpoint.xs ? 'small-text' : ''">{{ strings[idioma].minimo_porcentagem }}</div>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    pr-1
                    pl-1
                    xs4>
                    <v-layout
                      align-center
                      justify-center
                      column
                    >
                      <v-menu
                        :close-on-content-click="true"
                        :top="menuPosition === 'top'"
                        :botton="menuPosition === 'botton'"
                        center
                        offset-y
                        transition="slide-x-transition"
                      >
                        <template
                          slot="activator"
                          slot-scope="{ on }">
                          <span>
                            <v-text-field
                              :disabled="user.permissao !== 0 && (edicaoBloqueada || (props.item.id === ID_LEITE_VACA && restricoes.tipoEntrada !== '/MS'))"
                              :name="'maximo[' + props.item.id + ']'"
                              :id="'maximo[' + props.item.id + ']'"
                              v-model.lazy="props.item.maximo"
                              outline
                              class="text-field-table"
                              color="primary"
                              pattern="\d*"
                              inputmode="decimal"
                              v-on="on"
                              @click.native="testMenuPosition"
                              @keypress="val => onlyFloat(val, props.item, 'maximo')"
                              @dblclick="(props.item.maximo === 0 || props.item.maximo === '') ? props.item.maximo = getMaximoSalvo(props.item) : null"
                              @change="(val) => setMaximo(val, props.item)"
                            />
                          </span>
                        </template>
                        <template v-slot:default>
                          <v-card :style="(getMaximosSalvos(props.item).length === 0) ? 'height:0px; display:none;' : ''">
                            <v-list :style="heightHint">
                              <v-list-tile
                                v-for="(item, index) in new Set(getMaximosSalvos(props.item).map(i => i.toFixed(2).replace('.', strings[idioma].separador_float)))"
                                :key="index"
                                @click="props.item.maximo = item"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ item }}</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                          </v-card>
                        </template>

                      </v-menu>
                      <div
                        v-if="restricoes.tipoEntrada === '/MS' || props.item.id === ID_LEITE_VACA"
                        :class="$vuetify.breakpoint.xs ? 'small-text' : ''">{{ strings[idioma].maximo }}</div>
                      <div
                        v-else
                        :class="$vuetify.breakpoint.xs ? 'small-text' : ''">{{ strings[idioma].maximo_porcentagem }}</div>

                    </v-layout>

                  </v-flex>
                  <v-flex
                    xs1>
                    <v-layout
                      alignment = "center"
                      align-center
                      justify-center
                    >
                      <a
                        v-if="user.permissao === 0 || ((props.item.id !== ID_LEITE_VACA && !edicaoBloqueada))"
                        small
                        style="max-width: 5px"
                        flat
                        @click="restricoes.indexAlimentoDialog = alimentos_selecionados.findIndex(el => el.id === props.item.id); removeAlimento(restricoes.indexAlimentoDialog);">
                        <v-icon
                        >mdi-close</v-icon>
                      </a>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div
                  v-if="props.item.id === ID_UREIA && parseString(props.item.minimo, idioma) > 0.3 && restricoes.tipoEntrada !== '/%'"
                  class="error pa-2 text-xs-center">

                  <span
                    class="white--text"
                  >
                    {{ strings[idioma].msg_risco_ureia }}</span>

                </div>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-layout
      v-else
      align-center
      justify-center
      column>
      <h5>{{ strings[idioma].carregando }}</h5>
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate />
    </v-layout>

    <div
      v-if="restricoes.pagination.totalItems > restricoes.pagination.rowsPerPage"
      class="text-xs-center">
      <v-pagination
        v-model="restricoes.pagination.page"
        :length="Math.ceil(restricoes.pagination.totalItems / restricoes.pagination.rowsPerPage)"
        :total-visible="Math.ceil(restricoes.pagination.totalItems / restricoes.pagination.rowsPerPage) < restricoes.pagination.rowsPerPage + 2 ? Math.ceil(restricoes.pagination.totalItems / restricoes.pagination.rowsPerPage) : restricoes.pagination.rowsPerPage + 2"
        circle/>
    </div>
    <v-layout
      v-if="acesso_premium"
      :justify-center="$vuetify.breakpoint.xs"
      :justify-space-between="!$vuetify.breakpoint.xs"
      :column="$vuetify.breakpoint.xs"
      align-center
      wrap
    >
      <span style="color: #ffa21a; font-weight: 400"> {{ strings[idioma].alimento_alterado }} </span>
    </v-layout>
  </div>
</template>
<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<script>
import { mapState } from 'vuex'
import { TIPO_NUMBER, TIPO_FLOAT2, TIPO_FLOAT_LIVRE, TIPO_RADIOBUTTOM, TIPO_RESULTADO, TIPO_MONEY, TIPO_PORCENTAGEM, TIPO_PORCENTAGEM_LIVRE, ID_LEITE_VACA, CRESCIMENTO_TERMINACAO, BEZERRO, VACA, FEMEA, MAX_PESO_MACHO, MAX_PESO_FEMEA, MAX_PESO_BEZERRO, MIN_PESO_MACHO, MIN_PESO_FEMEA, MIN_PESO_BEZERRO, MAX_GMD, MACHO, MACHO_CASTRADO, FONTES_COMUNS } from '@/utils/types.js'
import { replaceSpecialChars } from '@/utils/vuex'
import { ID_UREIA } from '../../utils/types'
export default {
  props: {
    edicaoBloqueada: {
      type: Boolean,
      default: () => false
    },
    leituraBloqueada: {
      type: Boolean,
      default: () => true
    },
    dialog_nutrientes: {
      type: Boolean,
      default: () => true
    },
    step: {
      type: Number,
      default: () => 4
    },
    tree_alimentos: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    // disabled: false,
    TIPO_NUMBER: TIPO_NUMBER,
    TIPO_RADIOBUTTOM: TIPO_RADIOBUTTOM,
    TIPO_RESULTADO: TIPO_RESULTADO,
    TIPO_MONEY: TIPO_MONEY,
    TIPO_PORCENTAGEM: TIPO_PORCENTAGEM,
    TIPO_FLOAT2: TIPO_FLOAT2,
    TIPO_FLOAT_LIVRE: TIPO_FLOAT_LIVRE,
    TIPO_PORCENTAGEM_LIVRE: TIPO_PORCENTAGEM_LIVRE,
    CRESCIMENTO_TERMINACAO: CRESCIMENTO_TERMINACAO,
    BEZERRO: BEZERRO,
    VACA: VACA,
    FEMEA: FEMEA,
    MACHO: MACHO,
    MACHO_CASTRADO: MACHO_CASTRADO,
    MIN_PESO_MACHO: MIN_PESO_MACHO,
    MIN_PESO_FEMEA: MIN_PESO_FEMEA,
    MIN_PESO_BEZERRO: MIN_PESO_BEZERRO,
    MAX_PESO_MACHO: MAX_PESO_MACHO,
    MAX_PESO_FEMEA: MAX_PESO_FEMEA,
    MAX_PESO_BEZERRO: MAX_PESO_BEZERRO,
    MAX_GMD: MAX_GMD,
    ID_LEITE_VACA: ID_LEITE_VACA,
    ID_UREIA: ID_UREIA,
    formulacaoCarregada: null,
    menuPosition: 'botton',
    loading: false

  }),
  computed: {
    ...mapState('app', ['animal', 'strings', 'restricoes', 'idioma', 'optionsNumber', 'headersExigencias', 'exigencias', 'exigencias_selecionadas',
      'categorias_alimentos', 'alimentos_selecionados', 'ingredientes', 'composicao_racao', 'composicao_dieta', 'vc', 'fixavc', 'headersComposicaoRacao',
      'excrecao', 'headersExigenciasRelatorio', 'relatorio_financeiro', 'headersRelatorioFinanceiro', 'reset_options', 'trava_back', 'exporta_options',
      'exportando_dados', 'leiteDeVaca', 'dieta_calculada', 'acesso_premium', 'user']),
    disabled () {
      return this.edicaoBloqueada || this.leituraBloqueada
    },
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    filter () {
      return (item, search, textKey) => {
        return replaceSpecialChars(item[textKey]).toLowerCase().search(new RegExp(replaceSpecialChars(search.toLowerCase()), 'i')) > -1
      }
    },
    filterTable () {
      return (itens, search, textKey) => {
        textKey = (this.idioma === 0) ? 'name' : (this.idioma === 1) ? 'name_en' : 'name_es'
        return itens.filter((item) => replaceSpecialChars(item[textKey]).toLowerCase().search(new RegExp(replaceSpecialChars(search.toLowerCase()), 'i')) > -1)
      }
    },
    selectable () {
      return this.open.length > 0
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 120) + 'px; overflow: auto;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 200) + 'px; overflow: auto; min-height: 200px;'
    },
    fontesMineraisSelecionada () {
      return this.open.filter((a) => a.id === 8).length > 0
    },
    getSelecionaComunsStatus () {
      return this.fontesMineraisSelecionada && this.alimentos_selecionados.filter((a) => FONTES_COMUNS.filter((f) => f === a.id).length > 0).length > 0
    },
    getAlimentosToEdit () {
      return this.$store.state.app.alimentos_selecionados
    },
    heightHint () {
      return 'min-height: 0px; max-height: 100px; overflow: auto;'
    }
  },
  watch: {
    'loading' (val) {
      this.$store.state.app.loading = val
    },
    'dialog_nutrientes' (val) {
      this.$emit('dialogNutrientes', val)
    },
    'restricoes.tipoEntrada' (val) {
      if (this.step !== 4) {
        return
      }
      this.$store.commit('getDefaultAlimentos')
      this.$store.commit('getDefaultLeiteVaca')
      this.dietaCarregada = null
      this.dietaOtimizada = false
      this.$store.commit('setDietaCalculada', false)
    }
  },
  methods: {
    verificaPecuarista(){
      if (this.user && this.user.plano !== null && this.user.plano.tipo === 0) {
        return true
      }
      return false
    },

    sejaPremium () {
      this.$store.commit('openOKModal', {
        title: '',
        msg: this.strings[this.idioma].funcionalidade_exclusiva_premium
      })
    },
    testMenuPosition (ev) {
      if (this.$vuetify.breakpoint.height - ev.y < 300) {
        this.menuPosition = 'top'
      } else {
        this.menuPosition = 'botton'
      }
    },
    onlyFloat (val, input, tipo) {
      this.$onlyFloat(val, input, tipo, this.idioma)
    },
    parseString (valor, idioma) {
      return this.$parseString(valor, idioma)
    },
    removeAlimento (index) {
      this.$emit('removeAlimento', index)
    },
    getMinimoSalvo (alimento) {
      if (alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA
      return (alimento.stored.minimo === undefined || alimento.stored.minimo.length === 0) ? 0 : parseFloat(alimento.stored.minimo[alimento.stored.minimo.length - 1]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
    },
    getMinimosSalvos (alimento) {
      if (alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA
      let retorno = (alimento.stored === undefined || alimento.stored.minimo === undefined || alimento.stored.minimo.length === 0) ? [] : new Set(alimento.stored.minimo)
      return Array.from(retorno)
    },
    setMinimo (minimo, alimento) {
      alimento.minimo = alimento.minimo.replace((this.idioma === 0 || this.idioma === 2) ? '.' : ',', this.strings[this.idioma].separador_float)

      if (alimento.minimo === '0,00' || alimento.minimo === '0.00' || (this.parseString(alimento.minimo, this.idioma) > this.parseString(alimento.maximo, this.idioma) && this.parseString(alimento.maximo, this.idioma) !== 0)) { alimento.minimo = null }
      if (!(this.parseString(minimo, this.idioma) === 0)) {
        this.setValorSalvo(alimento)
      }
      this.$store.commit('setDietaCalculada', false)
    },
    getMaximoSalvo (alimento) {
      if (alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA

      return (alimento.stored.maximo === undefined || alimento.stored.maximo.length === 0) ? 0 : parseFloat(alimento.stored.maximo[alimento.stored.maximo.length - 1]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
    },
    getMaximosSalvos (alimento) {
      if (alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA

      let retorno = (alimento.stored === undefined || alimento.stored.maximo === undefined || alimento.stored.maximo.length === 0) ? [] : new Set(alimento.stored.maximo)
      return Array.from(retorno)
    },
    setMaximo (maximo, alimento) {
      alimento.maximo = alimento.maximo.replace((this.idioma === 0 || this.idioma === 2) ? '.' : ',', this.strings[this.idioma].separador_float)

      if (alimento.maximo !== null && alimento.maximo.trim() !== '') {
        if ((alimento.maximo === '0,00' || alimento.maximo === '0.00' || (parseFloat(alimento.maximo) === 0 && alimento.minimo === '') || this.parseString(alimento.minimo, this.idioma) > this.parseString(alimento.maximo, this.idioma))) {
          alimento.maximo = alimento.minimo
        }
        if (!(this.parseString(maximo, this.idioma) === 0)) {
          this.setValorSalvo(alimento)
        }
      } else {
        alimento.maximo = null
      }
      this.$store.commit('setDietaCalculada', false)
    },
    getCustoSalvo (alimento) {
      if (alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA
      if (alimento.id === ID_LEITE_VACA) return
      let custos = JSON.parse(localStorage.getItem('custos'))
      return (custos === null || (custos && custos[alimento.id] && custos[alimento.id].length === 0)) ? null : parseFloat(custos[alimento.id][custos[alimento.id].length - 1]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
    },
    getCustosSalvos (alimento) {
      if (alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA
      let custos = JSON.parse(localStorage.getItem('custos'))
      let retorno = (custos === null || (custos && custos[alimento.id] && custos[alimento.id].length === 0) || !(custos && custos[alimento.id])) ? [] : new Set(custos[alimento.id])
      if (Array.from(retorno).length > 0 && alimento.custo === null && !this.dieta_calculada) {
        alimento.custo = this.getCustoSalvo(alimento)
      }

      return Array.from(retorno)
    },
    setCusto (custo, alimento) {
      let custos = []
      if (alimento.id === ID_LEITE_VACA) return
      alimento.custo = alimento.custo.replace((this.idioma === 0 || this.idioma === 2) ? '.' : ',', this.strings[this.idioma].separador_float)
      const setCustoServer = () => {
        this.$store.commit('setDietaCalculada', false)
        let custos = JSON.parse(localStorage.getItem('custos'))
        if (!(this.parseString(custo, this.idioma) === 0)) {
          this.setValorSalvo(alimento)
          if (!custos[alimento.id]) custos[alimento.id] = []
          custos[alimento.id].push(this.parseString(custo, this.idioma))
          this.axios.post('users/salvaCustos', { 'custos': custos }).then((res) => {
            localStorage.setItem('custos', JSON.stringify(custos))
          })
        }
      }
      this.axios.post('users/getCustosUsuario').then((res) => {
        custos = res.data.data
        if (custos === null) custos = {}
        localStorage.setItem('custos', JSON.stringify(custos))
        setCustoServer()
      })
    },
    setValorSalvo (alimento) {
      const id = alimento.id
      if (alimento.id === ID_LEITE_VACA) return
      let alimentosStored = JSON.parse(localStorage.getItem('alimentosStored'))
      for (let al in alimentosStored) {
        if (alimentosStored[al].minimo_salvo !== undefined) {
          delete (alimentosStored[al].minimo_salvo)
          delete (alimentosStored[al].maximo_salvo)
          delete (alimentosStored[al].custo_salvo)
        }
      }
      localStorage.setItem('alimentosStored', JSON.stringify(alimentosStored))

      if (alimento.stored.minimo === undefined) alimento.stored.minimo = []
      if (alimento.stored.maximo === undefined) alimento.stored.maximo = []
      if (alimento.stored.custo === undefined) alimento.stored.custo = []
      if (alimento.stored.quantidade === undefined) alimento.stored.quantidade = []
      if (this.restricoes.tipoEntrada !== '/MS') return
      if (alimento.custo !== null && alimento.custo !== '' && this.parseString(alimento.custo, this.idioma) >= 0) {
        alimento.stored.custo.push(this.parseString(alimento.custo, this.idioma))
      }
      if (alimento.minimo !== null && alimento.minimo !== '' && this.parseString(alimento.minimo, this.idioma) >= 0) {
        alimento.stored.minimo.push(this.parseString(alimento.minimo, this.idioma))
      }
      if (alimento.maximo !== null && alimento.maximo !== '' && this.parseString(alimento.maximo, this.idioma) >= 0) {
        alimento.stored.maximo.push(this.parseString(alimento.maximo, this.idioma))
      }
      if (alimento.quantidade !== null && alimento.quantidade !== '' && this.parseString(alimento.quantidade, this.idioma) >= 0) {
        alimento.stored.quantidade.push(this.parseString(alimento.quantidade, this.idioma))
      }

      let al = JSON.parse(localStorage.getItem('alimentosStored'))
      al[id] = alimento
      localStorage.setItem('alimentosStored', JSON.stringify(al))
    }

  }
}
</script>
